import { Injectable } from '@angular/core';
import { ApiConfigService } from "./api-config.service";
import { SignInDto } from "../dtos/sign-in.dto";
import { Observable } from 'rxjs';
import { Router } from "@angular/router";
import { SignUpDto } from '../dtos/signUpDto';
import { UserDto } from '../dtos/userDto';


@Injectable()
export class AuthServiceService {
    public tokenType = "";
    public accessToken = "";
    public isLoggedIn = false;
    auth2: any = {};

    constructor(private apiConfig: ApiConfigService, private router: Router) {
        this.fbLibrary();
        this.googleLibrary();
    }

    authenticate(signInDto: SignInDto): Observable<any> {
        return this.apiConfig.post("api/auth/signin", signInDto);
    }

    signUp(signUpDto: SignUpDto): Observable<any> {
        return this.apiConfig.post("api/auth/signup", signUpDto);
    }

    getMe(): Observable<UserDto> {
        return this.apiConfig.get<UserDto>('api/auth/me') as unknown as Observable<UserDto>;
    }

    fbLibrary() {
        (window as any).fbAsyncInit = function () {
            window['FB'].init({
                appId: '551904865453616',
                cookie: true,
                xfbml: true,
                version: 'v7.0'
            });
            window['FB'].AppEvents.logPageView();
        };

        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));

    }

    googleLibrary() {
        var context = this;
        (window as any).googleSDKLoaded = function () {
            window['gapi'].load('auth2', () => {
                context.auth2 = window['gapi'].auth2.init({
                    client_id: '564623740534-o10l998s6o8heki2tb5m798kaps6uat8.apps.googleusercontent.com',
                    cookiepolicy: 'single_host_origin',
                    scope: 'profile email'
                });
            });
        };

        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) {
                return;
            }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://apis.google.com/js/platform.js?onload=googleSDKLoaded";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'google-jssdk'));
    }
}
